import { Component, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { SecureComponent } from './secure/secure.component';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ScrollPanel } from 'primeng/scrollpanel';
import { AppServiceManager } from '../common/services/appServiceManager';
import { DataService } from "./shared/data.service";
import { IRole } from './shared/Domains/role';
import { IMember } from './shared/Domains/member';
import { MemberService } from 'common/services/member.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'common/services/auth.service';
import { IUser } from './shared/Domains/IUser';
import { Configuration } from 'config/config';
import { IPackageBuider } from "app/shared/Domains/packageBuilder";
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IBranch } from './shared/Domains/branch';
@Component({
    selector: 'app-rightpanel',
    templateUrl:'./app.rightpanel.component.html'
})
export class AppRightpanelComponent implements AfterViewInit, OnInit {
    @ViewChild('scrollRightPanel') rightPanelMenuScrollerViewChild: ScrollPanel;
    dateCheck: any;
    members: any[];
    sourceMembers: any[];
    trainers: any[];
    sourceTrainers: any[];
    name: any;
    loading: boolean;
    check: any;
    memeberSetting: boolean = true;
    role: IRole;
    subscription: Subscription;
    packages: IPackageBuider[] = [];
    user: IUser;
    from: any;
    to: any;
    whatsAppCommunityLink: any;
    whatsAppCommunityLinkMessage: any;
    branch: IBranch;

    constructor(
        private LanguageService: LanguageService,
        public config: Configuration,
        private service: MemberService,
        private dataService: DataService,
        private confirmationService: ConfirmationService,
        public app: SecureComponent,
        private appServicemanager: AppServiceManager,
        private messageService: MessageService,
        private appServiceManager: AppServiceManager) { }

    ngOnInit() {
        this.role = AuthService.getLoggedInRole();
        if (this.role.name === "Admin" || this.role.name === "Super Admin"|| this.role.name === "Operator") {
            this.memeberSetting = false;
        } else {
            this.memeberSetting = true;
        }
        this.dateCheck = new Date();
        this.members = [];
        this.sourceMembers = [];
        this.from = null;
        this.to = null;
        this.trainers = [];
        this.sourceTrainers = [];
        this.getAllTrainersNotifications();
        this.getAllMembersNotifications();
        this.getPackages();
        this.getBranchById();
        this.service.events$.forEach(event => {
            if (event == 'defaulterRefreshclicked!') {
                this.getAllMembersNotifications();
            }
        });
        this.dataService.currentRefreshDefaulters.subscribe((currentData) => {
            if (currentData === "refreshDefaulters") {
                this.getAllMembersNotifications();
                this.getAllTrainersNotifications();
            }
        })
    }
	setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("AppRightpanelComponent", label);
      }
    // ngDoCheck(){
    //     console.log("DO CHECK")
    // }

    ngAfterViewInit() {
        setTimeout(() => { this.rightPanelMenuScrollerViewChild.moveBar(); }, 100);
    }
    openWhatsApp(member): string {

        let reciever = member.contact;
        if (member.contact) {

            let date = new Date(member.createdDate);
            let month = date.getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
            let monthName = date.toLocaleString('en-US', { month: 'long' }); // Get the month name
            let year = date.getFullYear();
            let data = {
                company  : this.user.company,
                branch   : this.user.branch,
                tagNumber: member.tagNumber
            }
            let url = "customers/defaulters/messageCount";
            this.appServicemanager.post(url, data).subscribe(
                (res: any) => {
                    this.getDefaulters();
                },
                (error: any) => {
                    this.messageService.clear();
                    this.messageService.add({ severity: "error", summary: "Error Message", detail: error, });
                }
            );
            let sessionData = localStorage.getItem('currentCompany');
            let parsedData = JSON.parse(sessionData);
            let name = parsedData.name;
            let msg = this.config.expiredFeeReminderMessage;
            if(this.role.branch == "651a591aae5ff029ba201bd6"){
                msg = this.config.jackedfeesMessage;
            }
            msg = msg.replace("{0}", member.name);
            msg = msg.replace("{1}", member.customerId);
            msg = msg.replace("{2}", month.toString());
            msg = msg.split("{3}").join(year.toString());
            msg = msg.replace("{4}", this.user.company);
            msg = msg.replace("{5}", this.user.branch);
            msg = msg.replace("{6}", monthName);
            msg = msg.replace("{7}", name);
            msg = msg.replace("{8}", "false");

            if(this.whatsAppCommunityLink){
                msg = msg.replace("{9}", this.whatsAppCommunityLinkMessage);
            }else{
                msg = msg.replace("{9}", "");
            }
            const message = encodeURIComponent(msg);

                const link = document.createElement('a');
                link.href = `https://wa.me/${reciever}?text=${message}`;
                link.target = '_blank';
                link.click();
                return '';
        } else {
            // Show error message here
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: 'This user does not have a phone number',
            });
            return '';
        }
    }
    getAllMembersNotifications() {
        this.from = '';
        this.to = '';
        this.name = '';
        this.user = AuthService.getLoggedInUser();
        this.members = [];
        this.loading = true;
        let filter = {
            company: this.user.company,
            branch: this.user.branch
        }
        this.getDefaulters();
        var user = JSON.parse(localStorage.getItem("currentUser"));
        // this.appServicemanager.post("customers/notifications", filter).subscribe((res: any) => {

        //     this.loading = false;
        // },
        //     (error) => {
        //         this.loading = false;
        //         this.messageService.clear();
        //         this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        //     });
    }
    getDefaulters() {
        this.user = AuthService.getLoggedInUser();
        this.loading = true;
        let url:any;
        if (this.from && this.to) {
            // this.from = new Date(this.from);
            // this.to = new Date(this.to);
            // this.to.setHours(23, 59, 59, 999)
            let fromDate = new Date(this.from);
            let toDate = new Date(this.to);
            let data = {
                from: fromDate.getFullYear() + "-" + ("0" + (fromDate.getMonth() + 1)).slice(-2) + "-" + ("0" + fromDate.getDate()).slice(-2),
                to: toDate.getFullYear() + "-" + ("0" + (toDate.getMonth() + 1)).slice(-2) + "-" + ("0" + toDate.getDate()).slice(-2),
            };
        url = `customers/defaulters/company/${this.user.company}/branch/${this.user.branch}?from=${data.from}&to=${data.to}`;
        }else{
        url = `customers/defaulters/company/${this.user.company}/branch/${this.user.branch}`;
        }
        if(this.from <= this.to){
        this.appServicemanager.get(url).subscribe(async (res: any) => {
            this.members = [];
            if (res !== null && res.length > 0) {
                this.members = res;
                this.loading = false;
                this.sourceMembers = res;
                this.members.forEach(async member => {
                    if (!member.messageCount) {
                      member.messageCount = 0;
                    }

                });
                this.members = this.members.sort((a, b) => { return <any>new Date(b.defaulterDate) - <any>new Date(a.defaulterDate) });
                await this.updateMemberFees();
            } else {
                this.messageService.clear();
                // this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Defaluter Found' });
                this.loading = false;
            }
            this.dataService.changeLength(this.members.length);
        },
        (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    }else{
        if(this.to){
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'From Date is greater than To Date' });
        }
    }
    }

    getBranchById() {
        this.loading = true;
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            this.whatsAppCommunityLink = this.branch.whatsappCommunityInvitationLink;
            this.whatsAppCommunityLinkMessage = "\n\nWe also have a vibrant WhatsApp community where our members share tips, motivation, and support each other's fitness journeys. If you'd like to join this community, simply tap on this link\n" + this.whatsAppCommunityLink;
        }
        if(!this.branch){
        this.appServiceManager.get('branches/' + AuthService.getLoggedInBranch()).subscribe((res) => {
            if (res) {
                this.whatsAppCommunityLink = res.whatsappCommunityInvitationLink;
                this.whatsAppCommunityLinkMessage = "\n\nWe also have a vibrant WhatsApp community where our members share tips, motivation, and support each other's fitness journeys. If you'd like to join this community, simply tap on this link\n" + this.whatsAppCommunityLink;
            } else {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
            }
            this.loading = false;
        },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        }
    }

    getPackages() {
        this.packages = [];
        this.loading = true;
        this.appServiceManager
            .get(
                "packagesBuilder/company/" +
                this.user.company +
                "/branch/" +
                this.user.branch
            )
            .subscribe(
                (res: IPackageBuider[]) => {
                    this.packages = res;
                    this.loading = false;
                },
                (error: any) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }

    async updateMemberFees() {
        for (const member of this.members) {
            if (member.packageId) {
                const packageInfo = this.packages.find(p => p._id === member.packageId);
                if (packageInfo) {
                    member.fee = packageInfo.packageFee;
                }
            }
        }
    }


    getAllTrainersNotifications() {
        this.members = [];
        this.loading = true;
        this.user = AuthService.getLoggedInUser();
        //this.getTrainersDefaulters();
        // this.appServicemanager.get("customers/trainerNotifications/company/" + this.user.company + '/branch/' + this.user.branch).subscribe((res: any) => {
        //     this.getTrainersDefaulters();
        //     this.loading = false;
        // },
        //     (error) => {
        //         this.loading = false;
        //         this.messageService.clear();
        //         this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        //     });
    }
    // getTrainersDefaulters() {
    //     this.loading = true;
    //     this.appServicemanager.get("customers/trainerDefaulters/company/" + this.user.company + '/branch/' + this.user.branch).subscribe((res: any) => {
    //         this.trainers = [];
    //         if (res !== null && res.length > 0) {
    //             this.trainers = res;
    //             this.loading = false;
    //             this.sourceTrainers = res;
    //             this.trainers = this.trainers.sort((a, b) => { return <any>new Date(b.defaulterDate) - <any>new Date(a.defaulterDate) });
    //         } else {
    //             this.messageService.clear();
    //             // this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
    //             this.loading = false;
    //         }
    //         this.dataService.changeTrainerLength(this.trainers.length);
    //     },
    //         (error) => {
    //             this.loading = false;
    //             this.messageService.clear();
    //             this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
    //         });
    // }
    searchLocal(value) {
        let matchedName = [];
        let matchedTagNumber = [];
        let matchedContact = [];
        let matchedEmail = [];
        if (value !== null && value !== undefined && value.toString().length > 0) {
            if (value == "") {
                this.members = Object.assign([], this.sourceMembers);
            }
            if (!value) {
                this.members = Object.assign([], this.sourceMembers);
            }
            if (value != "") {
                matchedContact = Object.assign([], this.sourceMembers).filter(
                    cust => cust.tagNumber ? cust.tagNumber.indexOf(value) > -1 : null);

                matchedName = Object.assign([], this.sourceMembers).filter(
                    cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
                const distinct = (value, index, self) => {
                    return self.indexOf(value) === index;
                }
                const source = matchedName.concat(matchedTagNumber, matchedContact, matchedEmail);
                this.members = source.filter(distinct);

                if (this.members.length === 0) {
                    this.members = [];
                    this.messageService.clear();
                    this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
                } else {
                    this.members = [...this.members];
                }
            }
        } else {
            this.members = Object.assign([], this.sourceMembers);
            this.members = [...this.members];
        }
    }
    searchTrainerLocal(value) {
        let matchedName = [];
        let matchedTagNumber = [];
        let matchedContact = [];
        let matchedEmail = [];
        if (value !== null && value !== undefined && value.toString().length > 0) {
            if (value == "") {
                this.trainers = Object.assign([], this.sourceTrainers);
            }
            if (!value) {
                this.trainers = Object.assign([], this.sourceTrainers);
            }
            if (value != "") {
                matchedContact = Object.assign([], this.sourceTrainers).filter(
                    cust => cust.tagNumber ? cust.tagNumber.indexOf(value) > -1 : null);

                matchedName = Object.assign([], this.sourceTrainers).filter(
                    cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
                const distinct = (value, index, self) => {
                    return self.indexOf(value) === index;
                }
                const source = matchedName.concat(matchedTagNumber, matchedContact, matchedEmail);
                this.trainers = source.filter(distinct);

                if (this.trainers.length === 0) {
                    this.trainers = [];
                    this.messageService.clear();
                    this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
                } else {
                    this.trainers = [...this.trainers];
                }
            }
        } else {
            this.trainers = Object.assign([], this.sourceTrainers);
            this.trainers = [...this.members];
        }
    }

    deleteDefaulter(defaulter: any) {
        this.confirmationService.confirm({
            message: "Are you sure you want to Delete Defaulter ?",
            accept: () => {
                this.loading = true;
                this.appServicemanager.delete("customers/deleteDefaulter/" + defaulter.customerId).subscribe((response: any) => {
                    const index: number = this.members.indexOf(defaulter);
                    if (index !== -1) {
                        this.members.splice(index, 1);
                    }
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Defaulter Successfully Deleted' });
                    this.dataService.changeLength(this.members.length);
                    this.dataService.refreshDefaulter
                }, (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                })
            }
        })
    }
    deleteTrainerDefaulter(mem: IMember) {
        this.confirmationService.confirm({
            message: "Are you sure you want to Delete Defaulter ?",
            accept: () => {
                this.loading = true;
                this.appServicemanager.delete("customers/deleteTrainerDefaulter/" + mem._id).subscribe((response: any) => {
                    const index: number = this.members.indexOf(mem);
                    if (index !== -1) {
                        this.members.splice(index, 1);
                    }
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Defaulter Successfully Deleted' });
                    this.dataService.changeTrainerLength(this.trainers.length);
                }, (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                })
            }
        })
    }

}
